var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,41.2v-3.6l3-2.9v6.5H6z M14.2,41.2V29.9l3-2.9v14.1L14.2,41.2L14.2,41.2z M22.5,41.2V27.1l3,2.9v11.2L22.5,41.2L22.5,41.2z M30.8,41.2V30l3-2.9v14.1L30.8,41.2L30.8,41.2z M39,41.2V22.3l3-2.9v21.8L39,41.2L39,41.2z M6,29.9v-4.1l14-13.3l8,7.6L42,6.8v4.1L28,24.3l-8-7.6L6,29.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.4b486aba21344bed263c7dbed6547136.svg";
export { ForwardRef as ReactComponent };